(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerTypeDeleteController',CustomerTypeDeleteController);

    CustomerTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerType'];

    function CustomerTypeDeleteController($uibModalInstance, entity, CustomerType) {
        var vm = this;
        vm.customerType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CustomerType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
